module.exports = __webpack_public_path__ + "img/skeleton.de16e80a.jpg";